export default {
    data() {
        return {
            headers: { Authorization: localStorage.getItem('Authorization')},
        }
    },

    methods: {

        teamMemberAPI_create(teamMember) {
            return this.axios.post(`${process.env.VUE_APP_ROOT_API}/api/teamMembers/`, teamMember, {headers: this.headers});
        },

        async teamMemberAPI_get_all() {
            let teamMembers = await this.axios.get(`${process.env.VUE_APP_ROOT_API}/api/teamMembers/`);
            return teamMembers.data;
        },

        teamMemberAPI_patch(teamMember) {
            return this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/teamMembers/${teamMember._id}`, teamMember, {headers: this.headers});
        },

        teamMemberAPI_delete(teamMember) {
            return this.axios.delete(`${process.env.VUE_APP_ROOT_API}/api/teamMembers/${teamMember._id}`, {headers: this.headers});
        }

    }
}



// WEBPACK FOOTER //
// ./src/mixins/api/teamMemberAPI.js